import { render, staticRenderFns } from "./etapas.vue?vue&type=template&id=509d43c0&scoped=true&"
import script from "./etapas.vue?vue&type=script&lang=js&"
export * from "./etapas.vue?vue&type=script&lang=js&"
import style0 from "./etapas.vue?vue&type=style&index=0&id=509d43c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509d43c0",
  null
  
)

export default component.exports